import { gql } from "@apollo/client";

const INITIATE_RULE_ENGINE = gql`
  mutation InitiateRuleEngine($params: IntelliUploadExecuteRuleInput!) {
    executeRule(params: $params) {
      message
    }
  }
`;

export default INITIATE_RULE_ENGINE;